import { useTranslation } from 'react-i18next'

import Chip from '@mui/material/Chip'

interface ChildPondChipProps {
  size?: 'small' | 'medium'
}

/** "บ่อลูก" badge for a pond whose cycle was opened by a transfer (DOF-1368). */
const ChildPondChip = ({ size = 'small' }: ChildPondChipProps) => {
  const { t } = useTranslation('pond')

  return (
    <Chip
      size={size}
      label={t('pond.child')}
      sx={{
        bgcolor: 'action.tonalBg',
        color: 'action.tonalFg',
        fontWeight: 600,
        flexShrink: 0,
        borderRadius: 0.5,
      }}
    />
  )
}

export default ChildPondChip
